import { css } from '@/styled-system/css';

export const mediaObjectRootStyles = css.raw({
  display: 'flex',
  alignItems: 'start',
  gap: 'default',
});
